import { AxiosResponse } from 'axios';

import routes from '@/config/routes';
import type { ApiResponse } from '../types';
import { v3Get, v3Post } from '@/api/axios.instance.V3';
import { ICreateGigReferClass, IGigReferAFriendClass } from '@/store/admin/types/types';

const getGigReferFriendList = async (data: IGigReferAFriendClass): Promise<AxiosResponse> => {
  return await v3Post(routes.backendUrl.referAFriend.getGigList, data);
};

const createFeaturedGig = async (gigReferClass: ICreateGigReferClass[]): Promise<AxiosResponse> => {
  return await v3Post(routes.backendUrl.referAFriend.createFeaturedGig, gigReferClass);
};

const deleteFeaturedGig = async (data: ICreateGigReferClass): Promise<AxiosResponse> => {
  return await v3Post(routes.backendUrl.referAFriend.deleteFeaturedGig, data);
};
const getReferFriendPayRates = (): ApiResponse => v3Get(routes.backendUrl.referAFriend.payRates);

export const referAFriendApi = {
  getGigReferFriendList,
  createFeaturedGig,
  deleteFeaturedGig,
  getReferFriendPayRates,
};
